import { Room as ApiRoom } from '../../shared-api/room';
import { RoomHistoryVisibility } from './room-history-visibility';
import { RoomMember } from './room-member';
import { RoomPowerLevel } from './room-power-level';

export interface Room extends ApiRoom {
  historyVisibility?: RoomHistoryVisibility;
  members: RoomMember[];
  tags: Record<string, Record<string, any>>;
  creator: string | null;
  avatarUrl: string | null;
  powerLevels: RoomPowerLevel;
  pinnedEventIds: string[];
}

export function blockRoom(room: Room): void {
  room.tags['isBlocked'] = { inProcess: true };
}

export function unblockRoom(room: Room): void {
  room.tags['isBlocked'] = { inProcess: false };
}
